import { useMutation, useQueryClient } from "@tanstack/react-query";
import { applyVoice } from "../lib/api";
import type { FingerprintOutput } from "../types/voice";

export const useApplyVoice = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      profile,
      systemPrompt,
    }: {
      profile: FingerprintOutput;
      systemPrompt: string;
    }) => applyVoice(profile, systemPrompt),
    // refetch (não só invalidate) garante que useVoice já tem dados novos
    // quando isPending cai pra false — evita UX de "resumo continua antigo até
    // refresh manual". onSuccess await aqui adia o estado terminal da mutation
    // até o GET /api/voice voltar.
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["voice"] });
    },
  });
};
